(function ($, Drupal) {

  Drupal.behaviors.tabs = {

    attach: function (context, settings) {

      function checkIfValidTab(tabType, tabToOpen) {
        if ($(tabType).find($('a[href="' + tabToOpen + '"]')).length === 0) {
          // Not found
          return '';
        }
        return tabToOpen;
      }

      function pageLoadOpenTab(tabType, tabToOpen) {
        $(tabType + ' .tab-button').removeClass('active');
        $(tabType + ' .tab-content').hide();
        // There are two hrefs for tabToOpen, one for desktop and one for mobile
        $('a[href="' + tabToOpen + '"]').each(function () {
          $(this).parent('.tab-button').addClass('active');
        });
        $(tabToOpen).show();
      }

      // Toggle pane display when a tab is clicked
      $(once('.tabs-list', '.tab-button')).each(function() {
        $(this).on('click', function(event) {
          event.preventDefault();
          var tabToOpen = $(this).find('a').attr('href');
          if (!$(this).hasClass('active')) {
            // Only close the tabs within standard or related
            var tabType = $(this).parent().parent().parent();
            tabType.find($('.tab-button')).removeClass('active');
            tabType.find($('.tab-content')).hide();
            $(this).addClass('active');
            $(tabToOpen).show();
            window.history.replaceState(null, null, tabToOpen);
          }
        });
      });

      // Make sure correct tab shown when page loaded
      $(once('.tabs-contents', 'html')).each(function() {
        var tabToOpen = window.location.hash;
        // We want to check if tabToOpen is a valid tab
        // If it isn't, then open the first one
        // We know it's valid if an href with that link exists
        if ($('.tab-button').length) {
          if (tabToOpen) {
            tabToOpen = checkIfValidTab('.tab-button', tabToOpen);
          }

          if (!tabToOpen) {
            // open first
            tabToOpen = '#' + $('.tab-content').first().attr('id');
          }

          if (tabToOpen) {
            pageLoadOpenTab('.services-facilities', tabToOpen);
          }
        }
      });
    }
  };
})(jQuery, Drupal);
